export const LT_PHONE_NUMBER = '+7 (495) 118-40-50';
export const LT_OFFICE_LOCATION = [37.69280433654785, 55.77911330381729];
export const NBSP = String.fromCharCode(160);
export const CDN_PATH = 'https://img.cdn.level.travel';
export const CDN_ASSETS = 'https://jsapi.cdn.level.travel/lt-modules-assets';

export const FORTUNA_TITLE = `В${NBSP}«Фортуну» входят все отели выбранной вами звездности. Но${NBSP}название своего отеля вы${NBSP}узнаете только в${NBSP}аэропорту прилета —${NBSP}у${NBSP}гида`;
export const FORTUNA_SUBTITLE = `Курорт, тип питания и${NBSP}количество звезд будут фиксированы, но${NBSP}название отеля вы${NBSP}узнаете только в${NBSP}аэропорту прилета —${NBSP}у${NBSP}гида или на${NBSP}стойке туроператора.`;
